import { ICheckPublishTermSchema } from '../../../../repositories/billing-tariffs/entities/PublishTerms/CheckPublishTermSchema';
import { IAuctionState } from '../../../../types/reducers/auction';
import { ICalltrackingState } from '../../../../types/reducers/calltracking';
import {
  EPlacingType,
  IPublishTermsService,
  IServicePackage,
  IServicePeriod,
} from '../../../../types/reducers/publishTerms';
import { mapAuctionTerm } from './mapAuctionTerm';
import { mapCalltrackingTerm } from './mapCalltrackingTerm';
import { mapPublishTerm } from './mapPublishTerm';
import { EMoneySource } from '../../../../types/reducers/user';

interface IGetPublishTermsParams {
  service: IPublishTermsService | null;
  servicePackage: IServicePackage | null;
  publicationPeriod: IServicePeriod | null;
  placingType: EPlacingType | null;
  auction: IAuctionState;
  isAuctionSelected: boolean;
  calltracking: ICalltrackingState;
  moneySource?: EMoneySource | null;
  increaseToMinimalTopBet: boolean;
  isWithoutServices: boolean;
  minimalBet: number;
  termsDurationInDays: number;
  currentBet: number;
}

export interface ICheckPublishTermWithMoneySource extends ICheckPublishTermSchema {
  moneySource?: EMoneySource | null;
}

export function getPublishTerms(params: IGetPublishTermsParams): ICheckPublishTermWithMoneySource[] {
  const {
    service,
    servicePackage,
    publicationPeriod,
    placingType,
    auction,
    isAuctionSelected,
    calltracking,
    moneySource,
    increaseToMinimalTopBet,
    isWithoutServices,
    minimalBet,
    termsDurationInDays,
    currentBet,
  } = params;

  const terms: ICheckPublishTermWithMoneySource[] = [];

  const serviceBet = service?.baseAuctionBet || 0;
  let bet = isAuctionSelected ? currentBet : serviceBet;

  // В рамках эксперимента MONEY-382 нельзя ставить меньше минимальной ставки
  if (increaseToMinimalTopBet) {
    bet = bet < minimalBet ? minimalBet : bet;
  }

  if (placingType === EPlacingType.balance && publicationPeriod) {
    const mappedTerm = mapPublishTerm(publicationPeriod);

    terms.push(mappedTerm);
  }

  if (placingType === EPlacingType.package && servicePackage) {
    const mappedTerm = mapPublishTerm(servicePackage);

    terms.push(mappedTerm);
  }

  if (auction.isEnabled && bet && auction.period) {
    const mappedTerm = mapAuctionTerm({
      bet: isWithoutServices ? 0 : bet,
      period: auction.period,
      days: termsDurationInDays,
    });

    terms.push(mappedTerm);
  }

  if (calltracking.isEnabled && calltracking.period) {
    const mappedTerm = mapCalltrackingTerm({
      period: calltracking.period,
    });

    terms.push(mappedTerm);
  }

  // Добавляем moneySource для каждого элемента, нужно для выбора счёта однократного размещения
  if (moneySource) {
    terms.forEach(term => {
      term.moneySource = moneySource;
    });
  }

  return terms;
}
